import React from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'semantic-ui-react';
import clsx from 'clsx';
import { commonNameAttributes, identifiableName } from '@/utils/resultsHelper';
import DialogWrapper from './DialogWrapper';
import Actions from '../buttons/Actions';
import DeleteOrCancel from '../buttons/DeleteOrCancel';

const ActionDialogForm = ({
  action = 'delete',
  children,
  className,
  entities,
  entity,
  identifiers = commonNameAttributes,
  inProgress,
  items,
  minimumDataEntryMet,
  modalIcon = 'trash',
  onClose,
  onClick,
  simple,
  theme,
}) => {
  const intl = useIntl();
  const actionText = () => (items.length === 1 ? `${entity}.${action}.button` : `${entities}.${action}.button`);

  const titleText = () => (items.length === 1
    ? intl.formatMessage({ id: `${entity}.${action}.title` })
    : intl.formatMessage({ id: `${entities}.${action}.title` }));

  const name = identifiableName(items, identifiers);

  return (
    <DialogWrapper
      className={clsx('aridhia-action-dialog-content', className, { smallwizard: items.length > 1 })}
      copyText={!simple && items.length === 1 ? name : undefined}
      icon={modalIcon}
      message={items.length === 1 ? `${entity}.${action}.text` : `${entities}.${action}.text`}
      messageIcon="warning circle"
      onClose={onClose}
      size={items.length === 1 ? 'tiny' : 'small'}
      theme={theme}
      title={titleText()}
      values={{ name: `'${name}'` }}
      warning
    >
      <Modal.Content scrolling>{children}</Modal.Content>
      {['delete', 'archive'].includes(action) && (
      <DeleteOrCancel
        deleteMessageId={actionText()}
        inProgress={inProgress}
        minimumDataEntryMet={minimumDataEntryMet}
        onClose={onClose}
        onDelete={onClick}
      />
      )}
      {!['delete', 'archive'].includes(action) && (
      <Actions
        minimumDataEntryMet={minimumDataEntryMet}
        onClose={onClose}
        onSave={onClick}
        inProgress={inProgress}
        saveMessageId={actionText()}
      />
      )}
    </DialogWrapper>
  );
};

export default ActionDialogForm;
